import React, { createContext, ReactNode, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { UserId } from "../../domain/user/UserId";
import { useAuthUser } from "../hooks/auth/useAuthUser";

type CareRecipientConfigPagePathParams = {
    kinds: "assessment_info" | "assessment_schedule" | "detection"
};

type ContextType = {
    tabIndex: number
    setTabIndex: React.Dispatch<React.SetStateAction<number>>
    userIdForDetection: UserId
    setUserIdForDetection: React.Dispatch<React.SetStateAction<UserId>>
};

const defaultContextValue: ContextType = {
    tabIndex: 0,
    setTabIndex: () => {},
    userIdForDetection: UserId.fromNothing(),
    setUserIdForDetection: () => {}
};

export const CareRecipientConfigContext = createContext(defaultContextValue);

export const CareRecipientConfigProvider = React.memo(function CareRecipientConfigProvider(props: Props) {
    const params = useParams<CareRecipientConfigPagePathParams>();

    const authUser = useAuthUser();

    const [tabIndex, setTabIndex] = useState(0);

    const [userIdForDetection, setUserIdForDetection] = useState<UserId>(authUser.id);

    const value: ContextType = useMemo(() => ({
        tabIndex: tabIndex,
        setTabIndex: setTabIndex,
        userIdForDetection: userIdForDetection,
        setUserIdForDetection: setUserIdForDetection
    }), [tabIndex, userIdForDetection]);

    useEffect(() => {
        if (params.kinds === "assessment_info") {
            setTabIndex(0);
        } else if (params.kinds === "assessment_schedule") {
            setTabIndex(1);
        } else if (params.kinds === "detection") {
            setTabIndex(2);
        } else {
            setTabIndex(0);
        }
    }, [params.kinds]);

    return (
        <CareRecipientConfigContext.Provider value={value}>{props.children}</CareRecipientConfigContext.Provider>
    );
});

type Props = {
    children: ReactNode
};
